/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputUavMissionLoiterArea
 */
export interface InputUavMissionLoiterArea {
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionLoiterArea
     */
    headingDeg?: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionLoiterArea
     */
    lat: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionLoiterArea
     */
    lng: number;
    /**
     * 
     * @type {number}
     * @memberof InputUavMissionLoiterArea
     */
    radiusM: number;
}

/**
 * Check if a given object implements the InputUavMissionLoiterArea interface.
 */
export function instanceOfInputUavMissionLoiterArea(value: object): boolean {
    if (!('lat' in value)) return false;
    if (!('lng' in value)) return false;
    if (!('radiusM' in value)) return false;
    return true;
}

export function InputUavMissionLoiterAreaFromJSON(json: any): InputUavMissionLoiterArea {
    return InputUavMissionLoiterAreaFromJSONTyped(json, false);
}

export function InputUavMissionLoiterAreaFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputUavMissionLoiterArea {
    if (json == null) {
        return json;
    }
    return {
        
        'headingDeg': json['headingDeg'] == null ? undefined : json['headingDeg'],
        'lat': json['lat'],
        'lng': json['lng'],
        'radiusM': json['radiusM'],
    };
}

export function InputUavMissionLoiterAreaToJSON(value?: InputUavMissionLoiterArea | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'headingDeg': value['headingDeg'],
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusM': value['radiusM'],
    };
}

